import React from "react";
import { ITipo_Campo } from "../../helpers/IFormHelper";

interface InputColumnProps {
  type: string;
  onchange: (headerId: string, value: string, tipo: ITipo_Campo) => void;
  headerId: string;
  tipo: ITipo_Campo;
  className: string;
}
export default function InputColumn({ type, onchange, headerId, tipo, className }: InputColumnProps) {
  const refTxt = React.createRef<HTMLInputElement>();
  return (
    <div>
      <input
        ref={refTxt}
        onChange={(e) => {
          onchange(headerId, refTxt.current?.value || "", tipo);
        }}
        className={className}
        type={type}
      />
    </div>
  );
}
